import { fetchAction, fetchActionPost  } from "../../../helpers/fetch";

// Get all shipping addresses
export const getShippingAddresses = () => fetchAction('/api/profile/shipping-addresses', [
    'GET_SHIPPING_ADDRESSES_REQUEST',
    'GET_SHIPPING_ADDRESSES_SUCCESS',
    'GET_SHIPPING_ADDRESSES_FAILURE'
]);

// Get a single shipping address by ID
export const getShippingAddressById = (addressId) => fetchAction(`/api/profile/shipping-addresses/${addressId}`, [
    'GET_SHIPPING_ADDRESS_REQUEST',
    'GET_SHIPPING_ADDRESS_SUCCESS',
    'GET_SHIPPING_ADDRESS_FAILURE'
]);

// Create a new shipping address
export const createShippingAddress = (addressData) => fetchActionPost(
    '/api/profile/shipping-addresses',
    addressData,
    [
        'CREATE_SHIPPING_ADDRESS_REQUEST',
        'CREATE_SHIPPING_ADDRESS_SUCCESS',
        'CREATE_SHIPPING_ADDRESS_FAILURE'
    ]
);

// Update an existing shipping address
export const updateShippingAddress = (addressId, addressData) => fetchActionPost(
    `/api/profile/shipping-addresses/${addressId}`,
    addressData,
    [
        'UPDATE_SHIPPING_ADDRESS_REQUEST',
        'UPDATE_SHIPPING_ADDRESS_SUCCESS',
        'UPDATE_SHIPPING_ADDRESS_FAILURE'
    ]
);

// Delete a shipping address
export const deleteShippingAddress = (addressId) => fetchActionPost(
    `/api/profile/shipping-addresses/${addressId}/delete`,
    {},
    [
        'DELETE_SHIPPING_ADDRESS_REQUEST',
        'DELETE_SHIPPING_ADDRESS_SUCCESS',
        'DELETE_SHIPPING_ADDRESS_FAILURE'
    ]
);

// Set an address as main/default
export const setMainShippingAddress = (addressId) => fetchActionPost(
    `/api/profile/shipping-addresses/${addressId}/set-main`,
    {},
    [
        'SET_MAIN_SHIPPING_ADDRESS_REQUEST',
        'SET_MAIN_SHIPPING_ADDRESS_SUCCESS',
        'SET_MAIN_SHIPPING_ADDRESS_FAILURE'
    ]
);

// Open shipping address form
export const openShippingAddressForm = () => ({
    type: 'OPEN_SHIPPING_ADDRESS_FORM'
});

// Close shipping address form
export const closeShippingAddressForm = () => ({
    type: 'CLOSE_SHIPPING_ADDRESS_FORM'
});

